import Chart from 'chart.js';
import classNames from 'classnames';
import {sum, sumBy} from 'lodash';
import map from 'lodash/map';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsLeagues} from '../../../../../actions/entities/statistics/leagues';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import {championshipsById} from '../../../../../components/ChampionshipSelector';
import DateRangePickerWrapper from '../../../../../components/DatePicker/DateRangePickerWrapper';
import Loader from '../../../../../components/Loader';
import {getIncrease} from '../../../../../helpers/stats';
import './index.css';

let chart;

class LeaguesWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {start, end, lang: 'ALL'};
  }

  fetchStats() {
    const {start, end} = this.state;
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsLeagues(
          {
            startDate: start,
            endDate: end,
          },
          null,
          (type, error) =>
            swal({
              title: `Oops...`,
              type: 'error',
              html:
                `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                `<pre><code>${JSON.stringify(
                  error,
                  undefined,
                  4,
                )}</code></pre>`,
            }),
        ),
      );
    }
  }

  componentDidMount() {
    const ctx = document.getElementById('leagues-stats-chart');
    if (ctx)
      chart = new Chart(ctx, {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
  }

  updateGraph(data) {
    const {creations} = data;
    const {lang} = this.state;

    const datasets = [
      {
        label: 'Mono',
        backgroundColor: '#ed9728',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Multi',
        backgroundColor: '#9fc99e',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
    ];

    map(creations, stat => {
      datasets[0].data.push({
        x: moment(stat.date).format('LL'),
        y: parseInt(sum(Object.values(stat[lang].mono)), 10),
      });
      datasets[1].data.push({
        x: moment(stat.date).format('LL'),
        y: parseInt(sum(Object.values(stat[lang].multi)), 10),
      });
    });

    chart.data.datasets = datasets;
    chart.update();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.updateGraph(nextProps.data);
    }
  }

  componentDidUpdate() {
    this.props.data && this.updateGraph(this.props.data);
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  static renderRow(
    name,
    current,
    previous,
    totalCurrent,
    creationsByChampionships,
  ) {
    const currentPercent = (current / totalCurrent) * 100;
    const infinity = previous === 0 && current !== 0;
    const increase = getIncrease(current, previous) || 0;

    return (
      <tr key={name} data-toggle="collapse" data-target={`.${name}`}>
        <td style={{width: '150px '}}>
          {name}
          <div className={`${name} collapse`}>
            {map(creationsByChampionships, (_value, index) => {
              return (
                <div key={index} className="text-right">
                  <b>{championshipsById[index].label}</b>
                </div>
              );
            })}
          </div>
        </td>
        <td>
          <b>{numeral(current).format('0,0')}</b>
          <div className={`${name} collapse`}>
            {map(creationsByChampionships, (value, index) => (
              <div key={index} className="text-left">
                {value.current}
              </div>
            ))}
          </div>
        </td>
        <td style={{width: '150px '}} className="text-center">
          {numeral(currentPercent).format('0')} %
        </td>
        <td style={{width: '150px '}} className="text-center">
          <b>{numeral(previous).format('0,0')}</b>
          <div className={`${name} collapse`}>
            {map(creationsByChampionships, (value, index) => (
              <div key={index} className="text-center">
                {value.previous}
              </div>
            ))}
          </div>
        </td>
        <td
          style={{width: '150px '}}
          className={classNames('text-center', {
            'text-green': current > previous,
            'text-red': previous > current,
          })}>
          {infinity ? (
            <span>
              +<span style={{fontSize: '18px'}}>∞</span>
            </span>
          ) : (
            numeral(increase).format('+0')
          )}{' '}
          %
        </td>
      </tr>
    );
  }

  static orderTable(table) {
    // No order for this widget
    return table;
  }

  renderTable(table) {
    if (!table) return false;

    const totalCurrent =
      sumBy(Object.values(table.mono), 'current') +
      sumBy(Object.values(table.multi), 'current');

    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Ligue</th>
              <th>Nombre</th>
              <th className="text-center">%</th>
              <th className="text-center">vs S-1</th>
              <th className="text-center">% S-1</th>
            </tr>
          </thead>
          <tbody>
            {map(table, (mode, modeName) => {
              const sumCurrent = sumBy(Object.values(mode), 'current');
              const sumPrevious = sumBy(Object.values(mode), 'previous');
              return LeaguesWidget.renderRow(
                modeName,
                sumCurrent,
                sumPrevious,
                totalCurrent,
                mode,
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderLeaguesCreatedByMode() {
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    const table = data && data[lang];

    return (
      !isFetching &&
      table && <div className="mb-4">{this.renderTable(table)}</div>
    );
  }

  render() {
    const {end, start, lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="leagues-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-users" /> Ligues créées{' '}
              <small className="text-muted">leaguesCreatedByMode</small>
            </h3>
            <br />
            Nombres de ligues crées entre le {this.state.start} et le{' '}
            {this.state.end}
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <DateRangePickerWrapper
                  initialStartDate={moment(start)}
                  initialEndDate={moment(end)}
                  minimumNights={0}
                  onDatesChange={({startDate, endDate}) => {
                    this.setState({
                      start: moment(startDate).format('YYYY-MM-DD'),
                      end: moment(endDate).format('YYYY-MM-DD'),
                    });
                  }}
                />
                <button
                  className="ml-2 inline btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderLeaguesCreatedByMode()}
          <div
            className={classNames(
              'chart',
              this.props.data ? 'displayGraphs' : 'notDisplayGraphs',
            )}>
            <canvas id="leagues-stats-chart" />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.leagues,
  dispatch => ({dispatch}),
)(LeaguesWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Leagues/index.js